import "./Aboutus.css";

function AboutUs() {
  return (
    <div className="about-cont">
      <h1>Out History</h1>
      <p>
        RJ-Tour is my personal website for my learning and practicing purpose
        but the content is real and showing the beauty of Rajasthan the land of
        marathas their culture and the real nature beauty.
      </p>
      <h1>Out Mission</h1>
      <p>
        Our mission is to touch the horizon where the capabilities meets with
        the requirements of the clients and the transparency with the work and
        skills.
      </p>
      <h1>Out Vision</h1>
      <p>
        To show the excellence service and work which we appreciate by the
        clientsand build the trust.
      </p>
    </div>
  );
}
export default AboutUs;
